import type { FC } from 'react';
import ContentLoader from 'react-content-loader';

import { createArray } from 'app/utils/array';

import style from './style.scss';

interface Props {
  nbLines?: number;
}

const LINE_HEIGHT = 13;

const TieringListPlaceholder: FC<Props> = ({ nbLines = 5 }) => (
  <div className={style.container}>
    {createArray(nbLines).map((_, index) => (
      <div key={index} className={style.line}>
        <ContentLoader width={951}>
          <rect x={28} y={28} width={53} height={LINE_HEIGHT} />
          <rect x={404} y={28} width={161} height={LINE_HEIGHT} />
          <rect x={762} y={28} width={161} height={LINE_HEIGHT} />
        </ContentLoader>
      </div>
    ))}
  </div>
);

TieringListPlaceholder.displayName = 'TieringListPlaceholder';

export default TieringListPlaceholder;
